import clientportfolio from '../assets/images/clientportfolio.png'

const ClientPortfolio = () => {
  return (
    <div>
      <a href='#projects'>Client's <strong>Portfolio</strong></a>
      <img src={clientportfolio} alt='clientportfolio' className='' />
    </div>
  )
}

export default ClientPortfolio;